export const experienceConstants = {
    START: 'experience:start',
    STOP: 'experience:stop',
    EXPERIENCE: 'experience:experience',
    ADD: 'experience:add',
    UPDATE: 'experience:update',
    REMOVE: 'experience:delete',
    CLEAR: 'experience:clear',
};